import { createSelector } from '@reduxjs/toolkit';
import { getQuotaLandingTariffsConfig } from 'reactApp/modules/features/features.selectors';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { normalizeMobileTariffList } from 'reactApp/sections/MobileSubscriptionsPage/MobileSubscriptionsPage.helpers';
import { ITariffsMobile } from 'reactApp/sections/MobileSubscriptionsPage/MobileSubscriptionsPage.types';
import { RootState } from 'reactApp/store';
import { Product, Tariff } from 'reactApp/types/Billing';
import { ITariffsByTab } from 'reactApp/ui/TariffSectionNew/TariffsSection.types';
import { getTariffProductsByPeriods, isMonth6Period } from 'reactApp/utils/Period';

import { baseTariffSpace, baseYearProduct } from './TariffsPlans.helpers';

export const getTariffsList = createSelector(
    [
        (state: RootState) => ProductsSelectors.getTariffsForQuotaLanding(state),
        (state, actionName: string) => ProductsSelectors.getPromoTariffs(state, actionName, true),
        (state) => QuotaLandingSelectors.getAbLandingFeature(state),
        (state, actionName) => actionName,
        (state, actionName, isMobile) => isMobile,
        (state) => getQuotaLandingTariffsConfig(state),
    ],
    (nonSpecialTariffs, promoTariffs, isNewLanding, actionName, isMobile, config): ITariffsByTab[] | ITariffsMobile[] => {
        const tariffs: Tariff[] = actionName ? promoTariffs : nonSpecialTariffs;

        const list = tariffs.reduce((acc: ITariffsByTab[], tariffItem) => {
            const products = getTariffProductsByPeriods(
                tariffItem.products,
                tariffItem.products.some((item) => isMonth6Period(item.period))
            );

            if (products.yearProduct) {
                acc.push({
                    space: tariffItem.space,
                    tariffId: tariffItem.id,
                    isRecommended: tariffItem.id.includes(isNewLanding ? config.recommendedIdNew : config.recommendedId),
                    products,
                });
            }

            return acc;
        }, []);

        list.unshift({
            tariffId: 'base',
            space: { ...baseTariffSpace },
            isRecommended: false,
            isBase: true,
            products: {
                yearProduct: {
                    ...baseYearProduct,
                    space: baseTariffSpace,
                },
                monthProduct: undefined,
            },
        });

        if (isMobile) {
            const mobileTariffList = list.reduce((acc, item) => {
                // не показываем базовый тариф на таче
                if (item.isBase) {
                    return acc;
                }

                acc[item.space.original] = [item.products.yearProduct, item.products.monthProduct];
                return acc;
            }, <Record<number, [Product, Product | undefined]>>{});

            return normalizeMobileTariffList(mobileTariffList, Boolean(actionName));
        }

        return list;
    }
);
